import { Injectable } from "@angular/core";
import { Router, RoutesRecognized } from "@angular/router";
import { filter, pairwise } from "rxjs/operators";
import { Location } from "@angular/common";

@Injectable({
  providedIn: "root",
})
export class HistoryLocationService {
  private LOCATION_HISTORY_KEY = "evaluation_history";
  private ADMIN_LAST_PLACE;

  constructor(private router: Router, private location: Location) {
    router.events
      .pipe(
        filter((event) => event instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((e: any) => {
        localStorage.setItem(this.LOCATION_HISTORY_KEY, e[0].urlAfterRedirects);
      });
  }

  goBackEvaluation() {
    const history = localStorage.getItem(this.LOCATION_HISTORY_KEY);

    if (history && history.indexOf("/captar/veiculos?") > -1) {
      this.router.navigateByUrl(history);
      return;
    }

    if (
      history &&
      (history.indexOf("/captar/historico?") > -1 ||
        history.indexOf("/captar/historico") > -1)
    ) {
      this.router.navigateByUrl(history);
      return;
    }

    if (history && history.indexOf("/captar/veiculos/novo") > -1) {
      this.router.navigateByUrl("/captar/veiculos");
      return;
    }

    if (history && history.indexOf("/captar/veiculos") > -1) {
      this.router.navigateByUrl("/captar/veiculos");
      return;
    }

    if (window.history.length > 1) {
      this.location.back();
      return;
    }

    this.router.navigate(["/captar/veiculos"]);
  }

  setAdminHistory(route: string) {
    this.ADMIN_LAST_PLACE = route;
  }

  goBackAdmin() {
    if (this.ADMIN_LAST_PLACE) {
      this.router.navigate([this.ADMIN_LAST_PLACE]);
    }
    this.location.back();
  }
}
